import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { getUploadHistoriesCount } from '@apis/esimBulk/upload';

export const useUploadHistoriesCount = () => {
  const queryOptions: UseQueryOptions<number, Error> = {
    queryKey: ['uploadHistoriesCount'],
    queryFn: () => {
      return getUploadHistoriesCount();
    },
  };
  return useQuery(queryOptions);
};
